import axios from 'axios';

import { TAddResponsibles } from '../../types/TLocationGroup';

export default async function addResponsibles({
  accessToken,
  locationGroupId,
  responsibleIds,
  setTokenLikeExpired,
  setIsAddingResponsibles,
}: TAddResponsibles) {
  try {
    if (setIsAddingResponsibles) setIsAddingResponsibles(true);
    const { data } = await axios.post(
      `${process.env.REACT_APP_LOCATION_GROUPS_API_URL}/responsible/add/${locationGroupId}`,
      { responsibleIds },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err: any) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  } finally {
    if (setIsAddingResponsibles) setIsAddingResponsibles(false);
  }
}
